/***
 * GO TO TOP BUTTON
 */

const btnToTop = document.querySelector('.btnToTop')

btnToTop.addEventListener('click', () => {
    window.scroll({ top: 0, behavior: 'smooth' })
})

window.addEventListener('scroll', () => {
    if(window.scrollY > 100) {
        btnToTop.style.transform = "translateX(0)"
    }
    else {
        btnToTop.style.transform = "translateX(200px)"
    }
})